import React from 'react'
import { Field, reduxForm, SubmissionError } from 'redux-form'
import { Form, Row, Col, Button } from 'react-bootstrap';
import { Rating } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { setModalView } from '../../actions';
import { emailLogin } from '../../actions/userActions';


class ReviewForm extends React.Component {
    state = { rating: 0 };

    componentDidMount() {
        //after loading the review form
        if (this.props.initialRate) {
            this.props.dispatch(this.props.change('rate', this.props.initialRate));
            this.setState({ rating: this.props.initialRate })
        }
    }

    onSubmit = async (values, dispatch) => {
        this.props.onSubmit(values)

        //reseting the fields after submitting (inputs and rating)
        this.props.reset();
        this.props.dispatch(this.props.change('rate', 0));
        this.setState({ rating: 0 })
    }

    handleRate = (e, { rating, maxRating }) => {
        this.setState({ rating: rating });
        this.props.dispatch(this.props.change('rate', rating));
    }

    renderTitleBox = ({ input, label, type, meta: { asyncValidating, touched, error } }) => (
        <div>
            <Form.Group as={Row}>
                <Form.Label column sm={12}>{label}</Form.Label>
                <Col sm={12}>
                    <Form.Control {...input} type={type} placeholder='REQUIRED' />
                    {touched && error && <span style={{ color: 'red' }}>{error}</span>}
                </Col>
            </Form.Group>
        </div>
    )

    renderCommentBox = ({ input, label, type, meta: { asyncValidating, touched, error } }) => (
        <div>
            <Form.Group as={Row}>
                <Form.Label column sm={12}>{label}</Form.Label>
                <Col sm={12}>
                    <Form.Control {...input} as="textarea" type={type} placeholder='OPTIONAL' style={{ height: 150 }} />
                    {touched && error && <span style={{ color: 'red' }}>{error}</span>}
                </Col>
            </Form.Group>
        </div>
    )

    renderStarRating = ({ input, label, type, meta: { touched, error } }) => {
        return (
            <div>
                <Form.Group as={Row}>
                    <Form.Label column sm={12}>{label}</Form.Label>
                    <Col sm={12}>
                        <Rating defaultRating={this.props.initialRate} rating={this.state.rating} maxRating={5} type={type} onRate={this.handleRate} size='massive' />
                        {touched && error && <span style={{ color: 'red' }}>{error}</span>}
                    </Col>
                </Form.Group>
            </div>

        )
    }

    render() {
        const { handleSubmit, pristine, reset, submitting, error } = this.props
        return (
            <div className="review-form">
                <form onSubmit={handleSubmit(this.onSubmit)}>

                    <Field name="rate" type="number" component={this.renderStarRating} label="Your Rating (REQUIRED)" />
                    <Field name="reviewTitle" type="text" component={this.renderTitleBox} label="Comment Title (REQUIRED) - 15 Words Max" />
                    <Field name="comment" type="text" component={this.renderCommentBox} label="Comment Details (OPTIONAL) - 1,000 Words Max" />

                    <div className="pb-4">
                        {error && <strong>{error}</strong>}
                        <Button variant="primary" size="sm" type="submit" disabled={submitting}>
                            submit
                      </Button>
                    </div>
                </form>
            </div>
        )
    }
}

const validate = values => {
    const errors = {};
    ['rate', 'reviewTitle']
        .forEach(field => {
            if (!values[field]) {
                errors[field] = 'This is a required field'
            }
        })

    if (values.comment) {
        if (values.comment.length > 1000) errors.comment = 'Only 1,000 characters allowed'
    }
    if (values.title) {
        if (values.title.length > 200) errors.comment = 'Only 200 characters allowed'
    }
    return errors
}

// const mapStateToProps = (state) => {
// }

ReviewForm = connect(null, { emailLogin, setModalView })(ReviewForm);

export default reduxForm({
    form: 'reviewForm', // a unique identifier for this form
    validate,
    // asyncValidate,
    // asyncBlurFields: ['email']
})(ReviewForm)
